<mat-icon
  [svgIcon]="icon"
  (click)="onClick()"
  attr.aria-hidden="{{ ariaHidden }}"
  attr.aria-label="{{ ariaLabel }}"
  attr.title="{{ altText }}"
></mat-icon>
